import groq from 'groq';

export const EPISODE = groq`
  episode {
    audio,
    episodeTitle,
    link,
    podcastTitle,
    thumbnail,
    transcript,
  }
`;

export const EPISODE_CARD = groq`
  episode {
    thumbnail,
  }
`;
